<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import { SPR_TOKEN } from '@/constant'
export default {
  name: 'app',
}
</script>

<style lang="less">
html,
body {
  // padding-top: 60px;
  margin: 0;
  background-color: #eff3f6;
  font-family: 'Microsoft YaHei', 'Helvetica Neue', Helvetica, 'PingFang SC',
    'Microsoft YaHei', Tahoma, Arial, sans-serif !important;
}

a {
  text-decoration: none;
}

span {
  display: inline-block;
}

button,
input,
optgroup,
select,
textarea {
  font-family: 'Microsoft YaHei', 'Helvetica Neue', Helvetica, 'PingFang SC',
    'Microsoft YaHei', Tahoma, Arial, sans-serif !important;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', '微软雅黑',
    'Microsoft YaHei', Tahoma, Arial, sans-serif;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-weight: normal;
  font-stretch: normal;
  color: #43484d;
}

.container {
  width: 1200px;
  margin: auto;
}

.block-btn {
  display: inline-block;
  width: 100%;
}

.max-width {
  width: 100%;
}

.max-height {
  height: 100%;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.no-margin {
  margin: 0;
}

.no-padding {
  padding: 0;
}

.page-title {
  font-size: 26px;
  color: #354052;
  margin: 20px 0;
}

.table-shin-expand.el-table .el-table__expanded-cell {
  padding: 0;
}

.horizontal-padding-10-table.el-table .cell {
  padding: 0 10px;
}

.el-button.el-button--primary,
.el-button--primary:focus,
.el-button--primary:hover {
  background-color: #0082cc;
}

/* 弹窗风格统一样式  */
.el-dialog {
  .el-dialog__header {
    padding: 24px 24px 0 45px;
    .el-dialog__title {
      font-size: 24px;
      color: #354052;
    }
  }
  .el-dialog__body {
    padding: 26px 36px 26px 45px;
    .sub-title {
      font-size: 18px;
      color: #7f8fa4;
      margin: 10px 0;
    }
  }
  .el-dialog__footer {
    margin: 0 36px 26px 45px;
    padding: 18px 0 0 0;
    border-top: 1px solid #e0e6ed;
    .count {
      position: absolute;
      left: 45px;
      height: 36px;
      line-height: 36px;
      color: #7f8fa4;
      font-size: 14px;
    }
  }
  .dialog-reason {
    margin-top: 42px;
    .el-form-item {
      margin: 0;
    }
    .el-textarea textarea {
      width: 500px;
      height: 88px;
      resize: none;
    }
  }
}
/* 规定表格最小高度,用于解决表格加载效果显示不完全 */
table {
  min-height: 60px !important;
}
/* 提交订单时的加载效果*/
.comfirmLoading {
  background: rgba(0, 0, 0, 0.5) !important;
  .el-loading-text {
    color: #ccc !important;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?4c9dc51c